import { Link } from "react-router-dom"
import logo from "../assets/NAI_Logo.png"

const AuthLayout = ({ children, activeTab }) => {
  return (
    <div className="auth-container">
      <div className="container-fluid vh-100 d-flex align-items-center justify-content-center bg-light">
        <div className={`auth-card ${activeTab === "register" ? "auth-card-register" : ""}`}>
          {/* Logo and Header */}
          <div className="text-center mb-4">
            <div className="logo-container mb-3">
              {/*<div className="logo-arrows">
                <span className="arrow">»</span>
                <span className="arrow">»</span>
                <span className="arrow">»</span>
              </div>*/}
              <img src={logo} alt="Nurse Assist International" className="logo-img mb-2" />
              <p className="tagline text-muted">Building Pathways for Nurses to Australia</p>
            </div>
          </div>

          {/* Tab Navigation */}
          <div className="tab-navigation mb-4">
            <div className="row g-0">
              <div className="col-6">
                <Link to="/login" className={`tab-link ${activeTab === "login" ? "active" : ""}`}>
                  Log In
                </Link>
              </div>
              <div className="col-6">
                <Link to="/register" className={`tab-link ${activeTab === "register" ? "active" : ""}`}>
                  Register
                </Link>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="auth-content">{children}</div>
        </div>
      </div>
    </div>
  )
}

export default AuthLayout
